/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-quill components
import ReactQuill from "react-quill";

// react-quill styles
import "react-quill/dist/quill.snow.css";

// Custom styles for the SuiEditor
import styles from "./styles";

function SuiEditor(props) {
  const classes = styles();
  const modules = {
    toolbar: false,
  };

  return <ReactQuill theme="snow" {...props} className={classes.suiEditor} modules={modules} />;
}

export default SuiEditor;
